/* ============================================================
   SHEIKH SCENTS - Premium Visual + Conversion Layer JS (additive)
   Module 1: Scroll progress bar            (off by default, window.SS_FX)
   Module 2: 3D tilt on product cards       (off by default, window.SS_FX)
   Module 3: Quick-add on Dawn collection / search cards
   Module 4: Sticky add-to-cart bar on product pages
   Module 5: Email + SMS capture (announcement bar + popup + footer)
   Module 6: Back-in-stock alerts (email / SMS via Klaviyo)   NEW 2026-09-01
   Module 7: Accessibility polish for Dawn leftovers          NEW 2026-09-01
   Complements sheikh-motion.js (reuses window.ssQuickAdd).
   No dependencies. Pure ASCII.
   ============================================================ */
(function () {
  'use strict';
  if (window.__ssPremiumInit) return;
  window.__ssPremiumInit = true;

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE    = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  /* ---------- 1. Scroll progress bar ---------- */
  function initScrollBar() {
    if (REDUCED) return;
    var bar = document.createElement('div');
    bar.className = 'ss-scrollbar';
    bar.setAttribute('aria-hidden', 'true');
    document.body.appendChild(bar);
    var ticking = false;
    function update() {
      var h = document.documentElement;
      var max = (h.scrollHeight - h.clientHeight) || 1;
      var pct = Math.min(100, Math.max(0, (h.scrollTop || window.pageYOffset) / max * 100));
      bar.style.width = pct + '%';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  }

  /* ---------- 2. 3D tilt on cards ---------- */
  function initTilt() {
    if (REDUCED || !FINE) return;
    var MAX = 6; // degrees
    var cards = document.querySelectorAll('.ss-product-card, .ss-explorer__card');
    cards.forEach(function (card) {
      var raf = null;
      function onMove(e) {
        var r = card.getBoundingClientRect();
        var px = (e.clientX - r.left) / r.width;
        var py = (e.clientY - r.top) / r.height;
        var ry = (px - 0.5) * 2 * MAX;
        var rx = (0.5 - py) * 2 * MAX;
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          card.style.transform =
            'perspective(1200px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) translateY(-6px)';
        });
      }
      function reset() {
        if (raf) cancelAnimationFrame(raf);
        card.style.transform = '';
      }
      card.addEventListener('pointermove', onMove);
      card.addEventListener('pointerleave', reset);
      card.addEventListener('blur', reset, true);
    });
  }

  /* ---------- shared: refresh Dawn cart drawer + bubble ---------- */
  function refreshDrawer(sections) {
    try {
      if (!sections) return;
      var parser = new DOMParser();
      if (sections['cart-drawer']) {
        var drawer = document.querySelector('cart-drawer');
        var fresh = parser.parseFromString(sections['cart-drawer'], 'text/html').querySelector('cart-drawer');
        if (drawer && fresh) { drawer.innerHTML = fresh.innerHTML; drawer.classList.remove('is-empty'); }
      }
      if (sections['cart-icon-bubble']) {
        var bubble = document.getElementById('cart-icon-bubble');
        var fb = parser.parseFromString(sections['cart-icon-bubble'], 'text/html');
        var freshBubble = fb.querySelector('.shopify-section') || fb.body;
        if (bubble && freshBubble) bubble.innerHTML = freshBubble.innerHTML;
      }
    } catch (e) { /* non-fatal */ }
  }

  function fallbackAdd(variantId, btn, orig) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1, sections: 'cart-drawer,cart-icon-bubble' })
    }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function (data) {
        refreshDrawer(data.sections);
        var drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.open === 'function') drawer.open();
        btn.classList.add('is-added');
        btn.innerHTML = 'Added!';
        setTimeout(function () { btn.innerHTML = orig; btn.disabled = false; btn.classList.remove('is-added'); }, 2000);
      }).catch(function () { btn.innerHTML = orig; btn.disabled = false; });
  }

  /* ---------- 3. Card quick-add (Dawn cards) ---------- */
  var PLUS_SVG = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true" focusable="false"><path d="M8 2v12M2 8h12" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';

  function onCardQuickAdd(btn) {
    var orig = btn.innerHTML;
    if (btn.dataset.variantId) {
      if (window.ssQuickAdd) { window.ssQuickAdd(btn); }
      else { btn.disabled = true; btn.innerHTML = '...'; fallbackAdd(btn.dataset.variantId, btn, orig); }
      return;
    }
    btn.disabled = true;
    btn.innerHTML = '...';
    fetch('/products/' + btn.dataset.handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var avail = (p.variants || []).filter(function (v) { return v.available; });
        if (!p.available || avail.length === 0) { btn.innerHTML = 'Sold out'; return; }
        if (avail.length > 1) { window.location.href = p.url; return; }
        btn.dataset.variantId = avail[0].id;
        btn.disabled = false;
        btn.innerHTML = orig;
        if (window.ssQuickAdd) { window.ssQuickAdd(btn); }
        else { btn.disabled = true; btn.innerHTML = '...'; fallbackAdd(avail[0].id, btn, orig); }
      })
      .catch(function () { btn.innerHTML = orig; btn.disabled = false; });
  }

  /* Text of a control minus Dawn's hidden helpers (e.g. quick-add's hidden "Sold out" span) */
  function visibleText(el) {
    if (!el) return '';
    var c = el.cloneNode(true);
    var hid = c.querySelectorAll('.hidden, [hidden], .loading__spinner, .visually-hidden');
    for (var i = 0; i < hid.length; i++) hid[i].parentNode.removeChild(hid[i]);
    return (c.textContent || '').trim();
  }
  function isSoldOutBtn(btn) {
    return !!btn && (btn.hasAttribute('disabled') || /sold\s*out/i.test(visibleText(btn)));
  }

  function productHandleFromCard(card) {
    var link = card.querySelector('a[href*="/products/"]');
    if (!link) return null;
    var m = (link.getAttribute('href') || '').match(/\/products\/([^/?#]+)/);
    return m ? { handle: m[1], href: link.getAttribute('href').split('#')[0].split('?')[0] } : null;
  }

  function scanCards(root) {
    var cards = (root || document).querySelectorAll('.card-wrapper');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.dataset.ssQa) continue;
      if (card.classList.contains('ss-product-card')) { card.dataset.ssQa = 'skip'; continue; }
      /* Dawn native quick-add present: if it is a disabled "Sold out" button, swap in a notify-me link (Module 6) */
      var native = card.querySelector('.quick-add__submit');
      if (native) {
        card.dataset.ssQa = 'native';
        if (isSoldOutBtn(native)) swapSoldOut(card, native);
        continue;
      }
      var info = productHandleFromCard(card);
      if (!info) { card.dataset.ssQa = 'skip'; continue; }
      card.dataset.ssQa = '1';
      var host = card.querySelector('.card__inner') || card;
      host.classList.add('ss-qa-host');
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'ss-qa-btn';
      btn.dataset.handle = info.handle;
      btn.setAttribute('aria-label', 'Quick add to cart');
      btn.innerHTML = PLUS_SVG + '<span>Add</span>';
      btn.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation(); onCardQuickAdd(this);
      });
      host.appendChild(btn);
    }
  }

  function swapSoldOut(card, btn) {
    var info = productHandleFromCard(card);
    if (!info || btn.dataset.ssSwapped) return;
    btn.dataset.ssSwapped = '1';
    var titleEl = card.querySelector('.card__heading');
    var title = titleEl ? titleEl.textContent.trim() : 'this item';
    var a = document.createElement('a');
    a.className = 'ss-qa-notify';
    a.href = info.href + '#notify';
    a.textContent = 'Sold out -- notify me';
    a.setAttribute('aria-label', 'Sold out. Get notified when ' + title + ' is back in stock');
    btn.parentNode.replaceChild(a, btn);
  }

  function initCardQuickAdd() {
    scanCards(document);
    var targets = [];
    var grid = document.getElementById('ProductGridContainer');
    if (grid) targets.push(grid);
    var search = document.getElementById('predictive-search-results') || document.querySelector('#Search-Results, .search__results');
    if (search) targets.push(search);
    if (!targets.length) targets.push(document.querySelector('main') || document.body);
    var pending = null;
    var mo = new MutationObserver(function () {
      if (pending) return;
      pending = setTimeout(function () { pending = null; scanCards(document); }, 120);
    });
    targets.forEach(function (t) { mo.observe(t, { childList: true, subtree: true }); });
  }

  /* ---------- 4. Sticky add-to-cart ---------- */
  function readPrice(container) {
    if (!container) return '';
    var priceBox = container.querySelector('.price') || container;
    var onSale = priceBox.classList && priceBox.classList.contains('price--on-sale');
    var sale = priceBox.querySelector('.price__sale .price-item--sale');
    var reg = priceBox.querySelector('.price__regular .price-item--regular');
    if (onSale && sale) {
      var comp = priceBox.querySelector('.price__sale s');
      return (comp ? '<s>' + comp.textContent.trim() + '</s> ' : '') + sale.textContent.trim();
    }
    if (reg) return reg.textContent.trim();
    var any = priceBox.querySelector('.price-item--regular, .price-item');
    return any ? any.textContent.trim() : '';
  }

  function initStickyAtc() {
    var info = document.querySelector('.product__info-container');
    if (!info) return;
    var realBtn = info.querySelector('.product-form__submit[name="add"]');
    if (!realBtn) return;
    var titleEl = info.querySelector('.product__title h1') || info.querySelector('.product__title');
    var priceContainer = info.querySelector('[id^="price-"]');
    var mediaImg = document.querySelector('.product__media img, media-gallery img, .product__media-wrapper img');

    var bar = document.createElement('div');
    bar.className = 'ss-sticky-atc';
    bar.setAttribute('role', 'region');
    bar.setAttribute('aria-label', 'Add to cart');
    bar.innerHTML =
      '<div class="ss-sticky-atc__inner">' +
        (mediaImg ? '<div class="ss-sticky-atc__media"><img alt="" src="' + (mediaImg.currentSrc || mediaImg.src) + '"></div>' : '') +
        '<div class="ss-sticky-atc__text">' +
          '<p class="ss-sticky-atc__title"></p>' +
          '<p class="ss-sticky-atc__price"></p>' +
        '</div>' +
        '<button type="button" class="ss-sticky-atc__btn"><span class="ss-sticky-atc__btn-label"></span></button>' +
      '</div>';
    document.body.appendChild(bar);

    var stickyBtn = bar.querySelector('.ss-sticky-atc__btn');
    var stickyLabel = bar.querySelector('.ss-sticky-atc__btn-label');
    var titleOut = bar.querySelector('.ss-sticky-atc__title');
    var priceOut = bar.querySelector('.ss-sticky-atc__price');
    if (titleEl) titleOut.textContent = (titleEl.textContent || '').trim();

    function sync() {
      var disabled = realBtn.hasAttribute('disabled');
      stickyBtn.disabled = disabled;
      var span = realBtn.querySelector('span');
      stickyLabel.textContent = span ? span.textContent.trim() : 'Add to cart';
      priceOut.innerHTML = readPrice(priceContainer);
    }
    sync();

    stickyBtn.addEventListener('click', function () {
      if (stickyBtn.disabled) return;
      realBtn.click(); // native product-form handles add + opens cart drawer
    });

    var mo = new MutationObserver(sync);
    mo.observe(realBtn, { attributes: true, childList: true, subtree: true, characterData: true });
    if (priceContainer) mo.observe(priceContainer, { childList: true, subtree: true, characterData: true });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { bar.classList.toggle('is-visible', !e.isIntersecting); });
      }, { threshold: 0, rootMargin: '0px 0px -72px 0px' });
      io.observe(realBtn);
    }
  }

  /* ---------- shared: Klaviyo client API ---------- */
  var KL_COMPANY = 'TEAQuY';     // Klaviyo public key (safe to expose)
  var KL_LIST    = 'Uy6Uc9';     // "Email List"
  var KL_REV     = '2025-07-15';  // >= 2025-07-15 needed for the subscriptions consent object
  var OFFER_CODE = 'WELCOME10';
  var OFFER_PCT  = '10%';

  function store(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function save(k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} }

  function klPost(path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(KL_COMPANY), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': KL_REV },
      body: JSON.stringify(body)
    });
  }

  function klSubscribe(email, phone, wantSms, source) {
    var attrs = {};
    var subs = {};
    if (email) { attrs.email = email; subs.email = { marketing: { consent: 'SUBSCRIBED' } }; }
    if (phone && wantSms) { attrs.phone_number = phone; subs.sms = { marketing: { consent: 'SUBSCRIBED' } }; }
    attrs.subscriptions = subs;
    return klPost('subscriptions', { data: { type: 'subscription',
      attributes: { custom_source: source || 'Sheikh Scents Website',
        profile: { data: { type: 'profile', attributes: attrs } } },
      relationships: { list: { data: { type: 'list', id: KL_LIST } } } } });
  }

  /* ---------- 5. Email + SMS capture (announcement + popup + footer) ----------
     Phone is optional. It is only sent to Klaviyo when the number parses AND the
     TCPA consent box is ticked. Toll-free sender +1 877-535-2893 went live 2026-09-02. */
  function capFormHTML(btnLabel, idPrefix) {
    var id  = idPrefix + '-email';
    var pid = idPrefix + '-phone';
    var cid = idPrefix + '-sms';
    return '<form class="ss-cap-form" data-ss-cap novalidate>' +
      '<div class="ss-cap-form__row">' +
        '<label class="visually-hidden" for="' + id + '">Email address</label>' +
        '<input type="email" id="' + id + '" name="email" required placeholder="Your email address" autocomplete="email" inputmode="email" class="ss-cap-form__input">' +
        '<button type="submit" class="ss-cap-form__btn">' + btnLabel + '</button>' +
      '</div>' +
      '<div class="ss-cap-form__row ss-cap-form__row--phone">' +
        '<label class="visually-hidden" for="' + pid + '">Mobile number, optional</label>' +
        '<input type="tel" id="' + pid + '" name="phone" placeholder="Mobile number (optional, for texts)" autocomplete="tel" inputmode="tel" class="ss-cap-form__input">' +
      '</div>' +
      '<div class="ss-cap-consent" data-ss-cap-consent hidden>' +
        '<input type="checkbox" id="' + cid + '" name="sms_consent">' +
        '<label for="' + cid + '">Text me drops, restock alerts and offers. By checking this box you agree to receive recurring automated marketing text messages from Sheikh Scents at the number provided. Consent is not a condition of purchase. Msg &amp; data rates may apply. Msg frequency varies. Reply STOP to cancel, HELP for help. See our <a href="/policies/privacy-policy">Privacy Policy</a> and <a href="/policies/terms-of-service">Terms</a>.</label>' +
      '</div>' +
      '</form><p class="ss-cap-msg" data-ss-cap-msg role="status" aria-live="polite"></p>';
  }

  function wireForm(form) {
    if (!form || form.dataset.ssWired) return;
    form.dataset.ssWired = '1';
    var msg = form.parentNode.querySelector('[data-ss-cap-msg]');
    var phoneIn = form.querySelector('input[type="tel"]');
    var consentWrap = form.querySelector('[data-ss-cap-consent]');
    var consentIn = consentWrap ? consentWrap.querySelector('input[type="checkbox"]') : null;

    /* the consent box only appears once a number is actually typed */
    if (phoneIn && consentWrap) {
      phoneIn.addEventListener('input', function () {
        consentWrap.hidden = !phoneIn.value.trim();
        if (consentWrap.hidden && consentIn) consentIn.checked = false;
      });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var btn = form.querySelector('button[type="submit"]');
      var email = (input.value || '').trim();
      if (!email || email.indexOf('@') < 1) {
        if (msg) { msg.className = 'ss-cap-msg is-err'; msg.textContent = 'Please enter a valid email.'; }
        input.setAttribute('aria-invalid', 'true'); input.focus();
        return;
      }
      input.removeAttribute('aria-invalid');

      /* phone is optional, but a typed number must be valid and consented before we send it */
      var rawPhone = phoneIn ? (phoneIn.value || '').trim() : '';
      var phone = null, wantSms = false;
      if (rawPhone) {
        phone = normalizePhone(rawPhone);
        if (!phone) {
          if (msg) { msg.className = 'ss-cap-msg is-err'; msg.textContent = 'That mobile number does not look right. Use 10 digits, or clear the field to just get email.'; }
          phoneIn.setAttribute('aria-invalid', 'true'); phoneIn.focus();
          return;
        }
        phoneIn.removeAttribute('aria-invalid');
        if (!consentIn || !consentIn.checked) {
          if (msg) { msg.className = 'ss-cap-msg is-err'; msg.textContent = 'Tick the box to agree to texts, or clear the mobile number to just get email.'; }
          if (consentIn) consentIn.focus();
          return;
        }
        wantSms = true;
      }

      btn.disabled = true; var orig = btn.textContent; btn.textContent = '...';
      klSubscribe(email, phone, wantSms, 'Sheikh Scents Website').then(function (res) {
        if (res.ok || res.status === 202) {
          save('ssSubscribed_v1', '1'); save('ssEmailPopup_v1', String(Date.now()));
          if (msg) { msg.className = 'ss-cap-msg'; msg.innerHTML = 'You are in. Use code <strong>' + OFFER_CODE + '</strong> for ' + OFFER_PCT + ' off your first order.'; }
          form.style.display = 'none';
          if (msg) msg.setAttribute('tabindex', '-1'), msg.focus();
        } else { throw new Error('status ' + res.status); }
      }).catch(function (err) {
        if (msg) { msg.className = 'ss-cap-msg is-err'; msg.textContent = 'Something went wrong -- please try again.'; }
        btn.disabled = false; btn.textContent = orig;
        if (window.console) console.warn('Klaviyo subscribe failed', err);
      });
    });
  }

  function trapFocus(container, e) {
    var f = container.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function initEmailCapture() {
    /* announcement bar -- skip when the theme already renders its own announcement bar */
    var themeHasBar = document.querySelector('.announcement-bar, .utility-bar, [class*="announcement-bar"]');
    if (!themeHasBar && store('ssAnnounceClosed_v1') !== '1') {
      var ann = document.createElement('div');
      ann.className = 'ss-announce';
      ann.setAttribute('role', 'region');
      ann.setAttribute('aria-label', 'Announcement');
      ann.innerHTML = '<div class="ss-announce__inner">' +
        '<span class="ss-announce__msg">&#9670; Authentic Arabic &amp; niche fragrances -- $5.95 flat shipping, free over $50</span>' +
        '<button type="button" class="ss-announce__close" aria-label="Dismiss announcement">&times;</button>' +
        '</div>';
      document.body.insertBefore(ann, document.body.firstChild);
      ann.querySelector('.ss-announce__close').addEventListener('click', function () {
        ann.remove(); save('ssAnnounceClosed_v1', '1');
      });
    }

    /* footer inline capture */
    var footer = document.querySelector('.footer__content-top') || document.querySelector('.footer .page-width') ||
                 document.querySelector('footer .page-width') || document.querySelector('.footer');
    if (footer) {
      var fc = document.createElement('div');
      fc.className = 'ss-foot-cap';
      fc.innerHTML = '<h2 class="ss-foot-cap__title">Get ' + OFFER_PCT + ' off your first order</h2>' +
        '<p class="ss-foot-cap__sub">Fragrance drops, restock alerts &amp; subscriber-only offers.</p>' +
        capFormHTML('Subscribe', 'ss-foot');
      footer.insertBefore(fc, footer.firstChild);
      wireForm(fc.querySelector('form[data-ss-cap]'));
    }

    /* popup */
    var subscribed = store('ssSubscribed_v1') === '1';
    var last = store('ssEmailPopup_v1');
    var suppressed = subscribed || (last && (Date.now() - Number(last) < 7 * 864e5));
    if (suppressed) return;

    var pop = document.createElement('div');
    pop.className = 'ss-pop';
    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-modal', 'true');
    pop.setAttribute('aria-labelledby', 'ss-pop-title');
    pop.setAttribute('aria-describedby', 'ss-pop-sub');
    pop.hidden = true;
    pop.innerHTML =
      '<div class="ss-pop__overlay" data-ss-pop-close></div>' +
      '<div class="ss-pop__card">' +
        '<button type="button" class="ss-pop__close" data-ss-pop-close aria-label="Close">&times;</button>' +
        '<p class="ss-pop__eyebrow">Sheikh Scents</p>' +
        '<h2 class="ss-pop__title" id="ss-pop-title">Unlock ' + OFFER_PCT + ' off your first order</h2>' +
        '<p class="ss-pop__sub" id="ss-pop-sub">Join the list for a welcome code, early access to new arrivals, and restock alerts on the scents you love.</p>' +
        capFormHTML('Get my code', 'ss-pop') +
        '<p class="ss-pop__fine">No spam. Unsubscribe anytime.</p>' +
      '</div>';
    document.body.appendChild(pop);
    wireForm(pop.querySelector('form[data-ss-cap]'));

    var shown = false, timer, lastFocus = null;
    function openPop() {
      if (shown) return; shown = true;
      lastFocus = document.activeElement;
      pop.hidden = false;
      requestAnimationFrame(function () {
        pop.classList.add('is-open');
        var first = pop.querySelector('input[type="email"]');
        if (first) first.focus();
      });
      save('ssEmailPopup_v1', String(Date.now()));
      clearTimeout(timer); window.removeEventListener('scroll', onScroll);
    }
    function closePop() {
      pop.classList.remove('is-open');
      setTimeout(function () { pop.hidden = true; }, 320);
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }
    function onScroll() {
      var h = document.documentElement;
      var pct = (h.scrollTop || window.pageYOffset) / ((h.scrollHeight - h.clientHeight) || 1);
      if (pct > 0.4) openPop();
    }
    timer = setTimeout(openPop, 12000);
    window.addEventListener('scroll', onScroll, { passive: true });
    pop.querySelectorAll('[data-ss-pop-close]').forEach(function (el) { el.addEventListener('click', closePop); });
    document.addEventListener('keydown', function (e) {
      if (pop.hidden) return;
      if (e.key === 'Escape') closePop();
      if (e.key === 'Tab') trapFocus(pop.querySelector('.ss-pop__card'), e);
    });
  }

  /* ---------- 6. Back-in-stock alerts (Klaviyo) ---------- */
  var BIS_PCT  = '15%';
  var BIS_DAYS = '3 days';

  function normalizePhone(raw) {
    var s = (raw || '').trim();
    if (!s) return '';
    var digits = s.replace(/\D/g, '');
    if (s.charAt(0) === '+' && digits.length >= 10 && digits.length <= 15) return '+' + digits;
    if (digits.length === 10) return '+1' + digits;
    if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
    return null;
  }

  function currentVariantId() {
    var input = document.querySelector('.product-form form input[name="id"], form[action*="/cart/add"] input[name="id"]');
    if (input && input.value) return input.value;
    try { return String(window.ShopifyAnalytics.meta.selectedVariantId || window.ShopifyAnalytics.meta.product.variants[0].id); } catch (e) { return null; }
  }

  function bisPanelHTML(productTitle) {
    return '' +
      '<h2 class="ss-bis__title" id="ss-bis-title">Sold out -- get first dibs when it is back</h2>' +
      '<p class="ss-bis__sub" id="ss-bis-sub">Leave your email or mobile number and we will message you the moment <strong>' + productTitle + '</strong> is restocked, with a ' + BIS_PCT + ' code that is good for ' + BIS_DAYS + '.</p>' +
      '<form class="ss-bis__form" novalidate>' +
        '<div class="ss-bis__field">' +
          '<label for="ss-bis-email">Email</label>' +
          '<input type="email" id="ss-bis-email" name="email" autocomplete="email" inputmode="email" placeholder="you@example.com">' +
        '</div>' +
        '<div class="ss-bis__field">' +
          '<label for="ss-bis-phone">Mobile number <span class="ss-bis__opt">(optional, for a text)</span></label>' +
          '<input type="tel" id="ss-bis-phone" name="phone" autocomplete="tel" inputmode="tel" placeholder="(410) 555-0199">' +
        '</div>' +
        '<div class="ss-bis__consent" id="ss-bis-consent-wrap" hidden>' +
          '<input type="checkbox" id="ss-bis-sms" name="sms_consent">' +
          '<label for="ss-bis-sms">Text me restock alerts and offers. By checking this box you agree to receive recurring automated marketing text messages from Sheikh Scents at the number provided. Consent is not a condition of purchase. Msg &amp; data rates may apply. Msg frequency varies. Reply STOP to cancel, HELP for help. See our <a href="/policies/privacy-policy">Privacy Policy</a> and <a href="/policies/terms-of-service">Terms</a>.</label>' +
        '</div>' +
        '<button type="submit" class="ss-bis__btn">Notify me when it is back</button>' +
        '<p class="ss-bis__fine">You will also get occasional offers by email. Unsubscribe anytime.</p>' +
        '<p class="ss-bis__msg" role="status" aria-live="polite"></p>' +
      '</form>';
  }

  function initBackInStock() {
    var info = document.querySelector('.product__info-container');
    if (!info) return;
    var realBtn = info.querySelector('.product-form__submit[name="add"]');
    if (!realBtn) return;
    var titleEl = info.querySelector('.product__title h1') || info.querySelector('.product__title');
    var productTitle = titleEl ? titleEl.textContent.trim() : 'this fragrance';
    var pid = null;
    try { pid = String(window.ShopifyAnalytics.meta.product.id); } catch (e) { pid = null; }

    var panel = document.createElement('section');
    panel.className = 'ss-bis';
    panel.id = 'ss-bis';
    panel.setAttribute('aria-labelledby', 'ss-bis-title');
    panel.setAttribute('aria-describedby', 'ss-bis-sub');
    panel.hidden = true;
    panel.innerHTML = bisPanelHTML(productTitle.replace(/</g, '&lt;'));
    var productForm = realBtn.closest('.product-form') || realBtn.closest('form');
    if (productForm && productForm.parentNode) productForm.parentNode.insertBefore(panel, productForm.nextSibling);
    else info.appendChild(panel);

    var form = panel.querySelector('form');
    var emailIn = panel.querySelector('#ss-bis-email');
    var phoneIn = panel.querySelector('#ss-bis-phone');
    var consentWrap = panel.querySelector('#ss-bis-consent-wrap');
    var consentIn = panel.querySelector('#ss-bis-sms');
    var msg = panel.querySelector('.ss-bis__msg');
    var btn = panel.querySelector('.ss-bis__btn');

    phoneIn.addEventListener('input', function () { consentWrap.hidden = !phoneIn.value.trim(); });

    function soldOut() { return isSoldOutBtn(realBtn); }
    function sync() {
      var vid = currentVariantId();
      var was = !panel.hidden;
      var show = soldOut();
      panel.hidden = !show;
      if (show && vid && store('ssBis_' + vid) === '1') {
        form.hidden = true; msg.className = 'ss-bis__msg is-ok'; msg.textContent = 'You are on the list for this one. We will let you know the moment it is back.';
      } else if (show) {
        form.hidden = false; if (!msg.classList.contains('is-err')) { msg.textContent = ''; msg.className = 'ss-bis__msg'; }
      }
      if (show && !was && location.hash === '#notify') {
        setTimeout(function () { panel.scrollIntoView({ behavior: REDUCED ? 'auto' : 'smooth', block: 'center' }); emailIn.focus(); }, 150);
      }
    }
    sync();
    var mo = new MutationObserver(sync);
    mo.observe(realBtn, { attributes: true, childList: true, subtree: true, characterData: true });
    window.addEventListener('hashchange', sync);

    function fail(text, focusEl) {
      msg.className = 'ss-bis__msg is-err'; msg.textContent = text;
      if (focusEl) { focusEl.setAttribute('aria-invalid', 'true'); focusEl.focus(); }
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      emailIn.removeAttribute('aria-invalid'); phoneIn.removeAttribute('aria-invalid');
      var email = (emailIn.value || '').trim();
      var phoneRaw = (phoneIn.value || '').trim();
      var phone = normalizePhone(phoneRaw);
      var vid = currentVariantId();
      if (!vid) return fail('Sorry -- we could not read this product. Please refresh and try again.');
      if (!email && !phoneRaw) return fail('Enter an email address or a mobile number.', emailIn);
      if (email && email.indexOf('@') < 1) return fail('That email does not look right.', emailIn);
      if (phoneRaw && !phone) return fail('Enter a valid mobile number, e.g. (410) 555-0199.', phoneIn);
      if (phone && !consentIn.checked) return fail('To get a text, please tick the consent box (or leave the number blank for email only).', consentIn);

      var channels = [];
      var attrs = {};
      if (email) { channels.push('EMAIL'); attrs.email = email; }
      if (phone) { channels.push('SMS'); attrs.phone_number = phone; }

      btn.disabled = true; var orig = btn.textContent; btn.textContent = 'One moment...';
      var body = { data: { type: 'back-in-stock-subscription',
        attributes: { channels: channels, profile: { data: { type: 'profile', attributes: attrs } } },
        relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + vid } } } } };

      /* Last resort (catalog not synced / SMS rejected for this profile): log a "Requested Restock Alert"
         event on the profile so the request is never lost and a Klaviyo flow can still fire from that metric. */
      function logRequestEvent() {
        var props = { ProductName: productTitle, VariantId: vid, ProductId: pid, URL: location.href.split('#')[0], Channels: channels.join(',') };
        return klPost('events', { data: { type: 'event', attributes: {
          properties: props, metric: { data: { type: 'metric', attributes: { name: 'Requested Restock Alert' } } },
          profile: { data: { type: 'profile', attributes: attrs } } } } })
          .then(function (r) { if (r.ok || r.status === 202) { r.eventFallback = true; return r; } throw new Error('event ' + r.status); });
      }

      klPost('back-in-stock-subscriptions', body).then(function (res) {
        if (res.ok || res.status === 202) return res;
        /* SMS rejected for this profile (toll-free +18775352893 has been active since 2026-09-02)
           -> retry email-only so the request is never lost */
        if (channels.length === 2) {
          body.data.attributes.channels = ['EMAIL'];
          return klPost('back-in-stock-subscriptions', body).then(function (r2) { if (r2.ok || r2.status === 202) { r2.smsFallback = true; return r2; } return logRequestEvent(); });
        }
        return logRequestEvent();
      }).then(function (res) {
        /* record marketing consent the customer just gave (email always; SMS only with the checkbox) */
        klSubscribe(email, phone, !!(phone && consentIn.checked), 'Back in stock form').catch(function () {});
        save('ssBis_' + vid, '1');
        form.hidden = true;
        msg.className = 'ss-bis__msg is-ok';
        msg.textContent = res.smsFallback
          ? 'You are on the list. We could not add your number, so we will email you the moment it is back, with your ' + BIS_PCT + ' code.'
          : 'You are on the list. We will message you the moment it is back, with your ' + BIS_PCT + ' code (good for ' + BIS_DAYS + ').';
        msg.setAttribute('tabindex', '-1'); msg.focus();
      }).catch(function (err) {
        btn.disabled = false; btn.textContent = orig;
        fail('Something went wrong on our end -- please try again, or email Support@SheikhScents.com and we will add you by hand.');
        if (window.console) console.warn('Back in stock failed', err);
      });
    });
  }

  /* ---------- 7. Accessibility polish for Dawn leftovers (WCAG 2.1 AA) ---------- */
  function initA11y() {
    /* Dawn's PDP quantity label uses an aria-hidden span, so the input has no accessible name */
    var qty = document.querySelectorAll('input.quantity__input:not([aria-label])');
    for (var i = 0; i < qty.length; i++) qty[i].setAttribute('aria-label', 'Quantity');
    /* Skip link lives outside every landmark -> give it one */
    var skip = document.querySelector('a.skip-to-content-link');
    if (skip && !skip.closest('nav')) {
      var nav = document.createElement('nav');
      nav.setAttribute('aria-label', 'Skip links');
      skip.parentNode.insertBefore(nav, skip);
      nav.appendChild(skip);
    }
    /* Third-party iframes without a name (chat / preview bars) */
    var frames = document.querySelectorAll('iframe:not([title]):not([aria-label])');
    for (var j = 0; j < frames.length; j++) frames[j].setAttribute('title', frames[j].id || 'Embedded content');
  }

  ready(function () {
    /* v4 refined (2026-09-01): scroll bar + 3D tilt disabled; set window.SS_FX=true to re-enable */
    if (window.SS_FX) { initScrollBar(); initTilt(); }
    initCardQuickAdd();
    initStickyAtc();
    initEmailCapture();
    initBackInStock();
    initA11y();
  });
})();